import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

import { useBookingFlow } from './BookingFlow/useBookingFlow';
import StepDateTime from './BookingFlow/StepDateTime';
import StepCourts from './BookingFlow/StepCourts';
import StepReview from './BookingFlow/StepReview';
import WaitlistDialog from './BookingFlow/WaitlistDialog';

export default function BookingFlow() {
  const f = useBookingFlow();

  return (
    <div className="mobile-container min-h-screen pb-6">
      {/* Header */}
      <div className="bg-primary text-primary-foreground p-6">
        <div className="flex items-center gap-4">
          <Button
            variant="ghost"
            size="icon"
            onClick={f.goBack}
            data-testid="back-button"
            className="text-primary-foreground hover:bg-white/20"
          >
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <div>
            <h1 className="text-2xl font-black font-heading uppercase">Book Court</h1>
            <p className="text-sm opacity-90">Step {f.step} of 3</p>
          </div>
        </div>
      </div>

      {/* Progress bar */}
      <div className="bg-secondary h-2">
        <div
          className="bg-accent h-full transition-all duration-300"
          style={{ width: `${(f.step / 3) * 100}%` }}
        />
      </div>

      <div className="p-6">
        {f.step === 1 && (
          <StepDateTime
            locations={f.locations}
            selectedLocation={f.selectedLocation}
            selectedDate={f.selectedDate}
            selectedTimeSlot={f.selectedTimeSlot}
            duration={f.duration}
            minDate={f.minDate}
            maxDate={f.maxDate}
            timeSlots={f.timeSlots}
            slotPricing={f.slotPricing}
            slotAvailabilityMap={f.slotAvailabilityMap}
            availability={f.availability}
            courtsPricing={f.courtsPricing}
            breakInfo={f.breakInfo}
            operatingHoursDisplay={f.operatingHoursDisplay}
            isLocationClosed={f.isLocationClosed}
            isTimeSlotPast={f.isTimeSlotPast}
            getConsecutiveSlots={f.getConsecutiveSlots}
            onLocationChange={f.handleLocationChange}
            onDateChange={f.handleDateChange}
            onDurationChange={f.handleDurationChange}
            onTimeSlotClick={f.handleTimeSlotSelection}
            onNext={f.handleDateTimeNext}
          />
        )}

        {f.step === 2 && (
          <StepCourts
            selectedLocation={f.selectedLocation}
            selectedDate={f.selectedDate}
            selectedTimeSlot={f.selectedTimeSlot}
            duration={f.duration}
            courtsRequested={f.courtsRequested}
            courtsPricing={f.courtsPricing}
            sportPriceMap={f.sportPriceMap}
            availableSports={f.availableSports}
            specialRequests={f.specialRequests}
            onAddCourt={f.addCourt}
            onRemoveCourt={f.removeCourt}
            onUpdateSport={f.updateCourtSport}
            onSpecialRequestsChange={f.setSpecialRequests}
            onBack={() => f.goToStep(1)}
            onNext={() => f.goToStep(3)}
          />
        )}

        {f.step === 3 && (
          <StepReview
            selectedLocation={f.selectedLocation}
            selectedDate={f.selectedDate}
            selectedTimeSlot={f.selectedTimeSlot}
            duration={f.duration}
            courtsRequested={f.courtsRequested}
            courtsPricing={f.courtsPricing}
            specialRequests={f.specialRequests}
            loading={f.loading}
            getConsecutiveSlots={f.getConsecutiveSlots}
            onBack={() => f.goToStep(2)}
            onSubmit={f.handleSubmitBooking}
          />
        )}
      </div>

      <WaitlistDialog
        open={f.showWaitlistDialog}
        onOpenChange={f.closeWaitlistDialog}
        joiningWaitlist={f.joiningWaitlist}
        user={f.user}
        selectedLocation={f.selectedLocation}
        selectedDate={f.selectedDate}
        selectedTimeSlot={f.selectedTimeSlot}
        availability={f.availability}
        onClose={f.closeWaitlistDialog}
        onJoin={f.handleJoinWaitlist}
      />
    </div>
  );
}
